import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { Logo } from "@/components/Logo";

const LINKS = [
  { href: "#servicios", label: "Servicios" },
  { href: "#viajes", label: "Viajes" },
  { href: "#precios", label: "Precios" },
  { href: "#como-funciona", label: "Cómo funciona" },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (href) => {
    setOpen(false);
    const el = document.querySelector(href);
    if (el) {
      if (window.__lenis) window.__lenis.scrollTo(el, { offset: -80 });
      else el.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 left-0 right-0 z-50 backdrop-blur-xl bg-white/90 transition-[border-color,box-shadow] duration-300 ${
        scrolled ? "border-b border-brand-line shadow-[0_4px_24px_rgba(31,41,55,0.05)]" : "border-b border-transparent"
      }`}
    >
      <div className="mx-auto max-w-6xl px-6">
        <nav className="flex items-center justify-between h-[72px]">
          <a href="/" data-testid="logo-link" aria-label="Asistentes Virtual, inicio">
            <Logo size={30} />
          </a>

          <div className="hidden md:flex items-center gap-8">
            {LINKS.map((l) => (
              <button
                key={l.href}
                data-testid={`nav-${l.label.toLowerCase().replace(/\s/g, "-")}`}
                onClick={() => go(l.href)}
                className="text-[14.5px] text-[#5F5E5A] hover:text-brand-indigo transition-colors duration-200"
              >
                {l.label}
              </button>
            ))}
            <button
              data-testid="nav-cta-prueba-gratis"
              onClick={() => go("#contacto")}
              className="rounded-[10px] bg-brand-indigo px-5 py-2.5 text-[14px] font-medium text-white shadow-[0_4px_14px_rgba(79,70,229,0.28)] hover:-translate-y-0.5 transition-transform duration-200"
            >
              Pide tu propuesta
            </button>
          </div>

          <button
            className="md:hidden text-brand-ink"
            aria-label="Abrir menú"
            aria-expanded={open}
            data-testid="mobile-menu-toggle"
            onClick={() => setOpen((v) => !v)}
          >
            {open ? <X size={26} /> : <Menu size={26} />}
          </button>
        </nav>
      </div>

      {open && (
        <div className="md:hidden border-t border-brand-line bg-white px-6 py-5 flex flex-col gap-4" data-testid="mobile-menu">
          {LINKS.map((l) => (
            <button
              key={l.href}
              onClick={() => go(l.href)}
              className="text-left text-[15px] text-[#5F5E5A]"
              data-testid={`mobile-nav-${l.label.toLowerCase().replace(/\s/g, "-")}`}
            >
              {l.label}
            </button>
          ))}
          <button
            onClick={() => go("#contacto")}
            data-testid="mobile-nav-cta"
            className="rounded-[10px] bg-brand-indigo px-5 py-3 text-[15px] font-medium text-white text-center"
          >
            Pide tu propuesta
          </button>
        </div>
      )}
    </header>
  );
}
